/**
 * 全局 Namespace 统一入口
 * 用于跨模块引用多个 namespace
 * 
 * 注意：namespace 的实际定义在各 model 文件中
 * 此文件仅作为统一入口，方便跨模块引用
 */

// ========== 拖拉拽页面 模块 ==========

/**
 * 多维分析主 Model 的 namespace (旧的, 重构后会移除)
 * 文件位置: @/pages/datalab/pages/Multidimensional/Analysis/model.ts
 * 用途: 管理多维分析的主要状态，包括数据表、维度、指标、图表数据等
 */
export const CHART_OLD_NAMESPACE = 'Analysis/MultiAnalysis';

/**
 * 图表设置 Model 的 namespace
 * 文件位置: @/pages/datalab/pages/Multidimensional/Analysis/models/chartSettingsModel/index.ts
 * 用途: 管理图表的个性化显示设置
 */
export const CHART_SETTINGS_NAMESPACE = 'DragDrop/chartSettings';

/**
 * 操作区的 Model 的 namespace
 * 文件位置: @/pages/datalab/pages/Multidimensional/Analysis/models/builderModel
 * 用途: 管理 过滤条件, 统计指标, 分类维度等操作区的状态
 */
export const CHART_BUILDER_NAMESPACE = 'DragDrop/builder';





// ========== 拖拉拽页面 模块 结束 ==========
